<template>
  <div id="app" class="dashboard">
    <div class="content">
      <app-header></app-header>
      <app-content></app-content>
    </div>
  </div>
</template>

<script>
import AppHeader from "../reuseable_components/Header.vue";
import AppContent from "./Content.vue";

export default {
  name: "AdminDashboard",
  components: {
    "app-header": AppHeader,
    "app-content": AppContent,
  },

  // The old guard here read `this.token`, which this component never declared - so it
  // was always undefined and `undefined == ''` is false. It never once ran. Auth is
  // now handled by the router guard in main.js, which covers every /app route.

  data() {
    return {};
  },
};
</script>

<style lang="scss" scoped>
  @import '../../css/style.scss';
</style>
